import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { ISetOwnerAction } from '../../../../ts/ServerApi/types/actionNames';
import { setOwner } from '../../../actions/SetOwnerAction';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource, userCanManageAlerts } from './IEntityActionHelpers';

export const SetOwnerAction: IEntityAction<IContentInfo, ISetOwnerAction> = {
  name: EntityActionNames.SetOwner,
  translateName: Messages.changeOwner_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetOwnerAction, targetItems: IContentInfo[], state: AppState) => {
    return !!(availableActions && availableActions.setOwner)
      || userCanManageAlerts(state, targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => setOwner(targetItems)
};
